import {constants} from "../../../constants";

export default class PauseGame {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    PLAYTECH_handler(data) {
        if (this.playtechInterval) {
            clearInterval(this.playtechInterval);
        }

        const sendPauseNotification = (isPaused) => {
            const message = {
                _type: "ucip.pause.g2wPauseNotification",
                pause: isPaused
            };
            if (this.gb.settings.nativeMobileApp) {
                message.handled = true;
            }
            this.gb.emitters.emit.web.customMsg(JSON.stringify(message));
        };

        const shouldPause = data && data.pause === true;
        const shouldResume = data && data.pause === false;

        if (shouldPause) {
            if (this.gb.isSpinning) {
                this.playtechInterval = setInterval(() => {
                    if (!this.gb.isSpinning) {
                        clearInterval(this.playtechInterval);
                        this.gb.emitters.emit.game.pauseGame();
                        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('pause')) {
                            sendPauseNotification(true);
                        }
                    }
                }, 10); // Games on autoplay can stop spinning only for a fraction of a second. Timeout set to 10ms so this request can be handled while the game is not spinning.
            } else {
                this.gb.emitters.emit.game.pauseGame();
                if (this.gb.ptResFeat && this.gb.ptResFeat.includes('pause')) {
                    sendPauseNotification(true);
                }
            }
        }
        else if (shouldResume) {
            this.gb.emitters.emit.game.resumeGame();
            if (this.gb.ptResFeat && this.gb.ptResFeat.includes('pause')) {
                sendPauseNotification(false);
            }
        }
    }

    PLAYTECH_AUTOPLAYSTOP_handler() {
        this.gb.emitters.emit.game.suspendGame();
    }

    COMEON_handler() {
        let timeoutID;
        const gb = this.gb
        const checkIsSpinning = function() {
            if(gb.isSpinning === true) {
                timeoutID = window.setTimeout(checkIsSpinning, 100);
            } else {
                window.clearTimeout(timeoutID)
                gb.emitters.emit.game.pauseGame();
            }
        }
        checkIsSpinning();
    }

    PLAYTECH_VISIBILITY_handler(data) {
        if (this.gb.gameProviderCode !== 'GAM') {
            if (data && data.visible === false) {
                this.gb.emitters.emit.game.pauseGame();
                this.gb.emitters.emit.game.soundOff();
            } else if (data && data.visible === true) {
                this.gb.emitters.emit.game.resumeGame();
                this.gb.emitters.emit.game.soundOn();
            }
        }
    }

    _default() {
        this.gb.emitters.emit.game.pauseGame();
    }

    exposeEvent() {
        let event = {};
        switch (this.gb.walletProtocol) {
            case constants.EXCITE:
                event["playInterrupted"] = this._default;
                break;
            case constants.GIG:
                event["doGameSuspend"] = this._default;
                break;
            case constants.MGS:
                event["StopGamePlay"] = this._default;
                event["PAUSE_GAMEPLAY"] = this._default;
                event["pause_gameplay"] = this._default;
                break;
            case constants.PLAYTECH:
                event["ucip.pause.w2gPauseCommand"] = this.PLAYTECH_handler;
                event["ucip.autoplay.w2gInterruptGameplayCommand"] = this.PLAYTECH_AUTOPLAYSTOP_handler;
                event["ucip.displaystatus.w2gVisibilityChangeNotification"] = this.PLAYTECH_VISIBILITY_handler;
                break;
            case constants.COMEON:
                event["doGamePause"] = this.COMEON_handler;
                break;
            case constants.POKERSTARS:
                event["xc2rgPauseGame"] = this._default;
                break;
            default:
                event["doGamePause"] = this._default
        }

        return event;
    }
}
